
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic",
      function () {
        return require("private-next-pages/basic.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basic"])
      });
    }
  